const DROPDOWN_TEMPLATE = require('sma.admin/components/partials/dropdown.mustache');

class Dropdown extends Backbone.View {
	get events() {
		return {
			'click .sma-js-dropdown-activation': 'toggleDropdown',
			'click .sma-js-dropdown-expander': 'showMoreItems',
			'click .sma-js-dropdown': 'stopPropagation',
		};
	}

	get dropdown() {
		return this.$el.find('.sma-js-dropdown:first');
	}

	get isExpandedDisplayName() {
		return this.isExpanded ? gettext('LESS') : gettext('MORE');
	}

	get renderedDropdownTemplate() {
		return DROPDOWN_TEMPLATE({
			isExpandedDisplayName: this.isExpandedDisplayName,
			commonItems: this.commonItems,
			moreItems: this.moreItems,
			isExpanded: this.isExpanded,
		});
	}

	stopPropagation(e) {
		e.stopPropagation();
	}

	showMoreItems() {
		this.isExpanded = !this.isExpanded;
		this.updateDropdown();
	}

	toggleDropdown(e) {
		e.stopPropagation();

		// Since we stop propagaton on other dropdown buttons, we need to manually
		// hide and remove the active class on the other dropdowns.
		$('.sma-js-dropdown:visible').each((i, el) => {
			if(this.$el.find($(el)).length <= 0) {
				$(el).siblings('.sma-js-dropdown-activation').removeClass('sma-dropdown-active');
				$(el).toggle();
			}
		});

		this.dropdown.toggle();

		this.dropdownButton.hasClass('sma-dropdown-active') ?
			this.dropdownButton.removeClass('sma-dropdown-active') :
			this.dropdownButton.addClass('sma-dropdown-active');

		if (this.dropdownButton.hasClass('sma-dropdown-active')) {
			$(document).bind('click', this.toggler);
		}
		else {
			$(document).unbind('click', this.toggler);
		}
	}

	initialize(context) {
		if(!context.element) {
			console.error('element is null or undefined');
			return;
		}

		this.dropdownButton = $(context.element);
		this.dropdownButton.addClass('sma-js-dropdown-activation');

		this.setElement(context.element.parent());

		this.isExpanded = false;
		this.commonItems = context.commonItems;
		this.moreItems = context.moreItems;

		this.$el.append('<div class="sma-dropdown sma-js-dropdown"></div>');

		this.toggler = (e) => {
			this.toggleDropdown(e);
		};

		this.updateDropdown();
	}

	updateDropdown() {
		this.dropdown.empty();
		this.dropdown.append(this.renderedDropdownTemplate);
	}
}

module.exports = {
	Dropdown: Dropdown,
}
